module.exports = __webpack_public_path__ + "img/xchange.c45a1faa.png";